import { render, staticRenderFns } from "./ContactVolunteerButton.vue?vue&type=template&id=897e128a&"
import script from "./ContactVolunteerButton.vue?vue&type=script&lang=ts&"
export * from "./ContactVolunteerButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('897e128a')) {
      api.createRecord('897e128a', component.options)
    } else {
      api.reload('897e128a', component.options)
    }
    module.hot.accept("./ContactVolunteerButton.vue?vue&type=template&id=897e128a&", function () {
      api.rerender('897e128a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/ContactVolunteerButton.vue"
export default component.exports